import {
  SET_USER_ID,
  SET_CLIENT_ID,
  SET_EMAIL_ADDRESS,
  SET_HAS_ONBOARDED,
  SET_IS_ON_WEB,
  RECORD_DATA_CLIENT_ID,
  RECORD_DATA_CLIENT_IDS,
  REGISTER_LOGGED_IN,
  REGISTER_LOGGED_OUT,
  SET_CURRENT_APP_STATE_TO_DASHBOARD,
  SET_CURRENT_APP_STATE_TO_APP,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').Client} Client
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {Client}
 */
const INITIAL_STATE = {
  userId: null,
  clientId: null,
  emailAddress: null,
  hasOnboarded: null,
  isOnWeb: null,
  isLoggedIn: false,
  // dataClientIds is: {
  //   [<path-to-data-in-store>: <last-client-id-that-wrote-it>]*
  // }
  dataClientIds: {},
  legacy__currentAppState: null,
}

/**
 * @param {Client} state
 * @param {PltrAction} action
 * @return {Client}
 */
const clientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USER_ID:
      return {
        ...state,
        userId: action.userId,
      }
    case SET_CLIENT_ID:
      return {
        ...state,
        clientId: action.clientId,
      }
    case SET_EMAIL_ADDRESS:
      return {
        ...state,
        emailAddress: action.emailAddress,
      }
    case SET_HAS_ONBOARDED: {
      return {
        ...state,
        hasOnboarded: action.hasOnboarded,
      }
    }
    case SET_IS_ON_WEB: {
      return {
        ...state,
        isOnWeb: true,
      }
    }
    case RECORD_DATA_CLIENT_ID: {
      return {
        ...state,
        dataClientIds: {
          ...state.dataClientIds,
          [action.path]: action.clientId,
        },
      }
    }
    case RECORD_DATA_CLIENT_IDS: {
      return {
        ...state,
        dataClientIds: action.paths.reduce((existingPaths, nextPath) => {
          return {
            ...existingPaths,
            [nextPath]: action.clientId,
          }
        }, state.dataClientIds),
      }
    }
    case REGISTER_LOGGED_IN: {
      return {
        ...state,
        isLoggedIn: true,
      }
    }
    case REGISTER_LOGGED_OUT: {
      return {
        ...state,
        isLoggedIn: false,
      }
    }
    case SET_CURRENT_APP_STATE_TO_DASHBOARD: {
      return {
        ...state,
        legacy__currentAppState: 'DASHBOARD',
      }
    }
    case SET_CURRENT_APP_STATE_TO_APP: {
      return {
        ...state,
        legacy__currentAppState: 'DASHBOARD',
      }
    }
    default:
      return state
  }
}

export default clientReducer
